import { render, staticRenderFns } from "./upgradeNotification.vue?vue&type=template&id=0e23d40e"
import script from "./upgradeNotification.vue?vue&type=script&lang=js"
export * from "./upgradeNotification.vue?vue&type=script&lang=js"
import style0 from "./upgradeNotification.vue?vue&type=style&index=0&id=0e23d40e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports